export default __webpack_public_path__ + "static/media/Believer's Jerkin of the Soaring God.fae35f53.jpg";